import { CountryId } from '../country/CountryId'
import { Codebook } from '../Codebook'

export class CountryVisaRequirement extends Codebook<CountryId> {
  static readonly CZE_REQUIREMENTS = new CountryVisaRequirement(CountryId.CZE, [
    CountryId.AFG,
    CountryId.DZA,
    CountryId.AGO,
    CountryId.ARM,
    CountryId.BHR,
    CountryId.BGD,
    CountryId.BLZ,
    CountryId.BLR,
    CountryId.BEN,
    CountryId.BTN,
    CountryId.BOL,
    CountryId.BWA,
    CountryId.BFA,
    CountryId.BDI,
    CountryId.CHN,
    CountryId.DOM,
    CountryId.DJI,
    CountryId.TCD,
    CountryId.EGY,
    CountryId.ECU,
    CountryId.ERI,
    CountryId.ETH,
    CountryId.FJI,
    CountryId.PHL,
    CountryId.GAB,
    CountryId.GMB,
    CountryId.GHA,
    CountryId.GIN,
    CountryId.GNB,
    CountryId.GUY,
    CountryId.HTI,
    CountryId.IND,
    CountryId.IDN,
    CountryId.IRQ,
    CountryId.IRN,
    CountryId.JAM,
    CountryId.YEM,
    CountryId.ZAF,
    CountryId.JOR,
    CountryId.KHM,
    CountryId.CMR,
    CountryId.CPV,
    CountryId.QAT,
    CountryId.KAZ,
    CountryId.KEN,
    CountryId.COM,
    CountryId.COG,
    CountryId.COD,
    CountryId.PRK,
    CountryId.CUB,
    CountryId.KWT,
    CountryId.KGZ,
    CountryId.LAO,
    CountryId.LSO,
    CountryId.LBN,
    CountryId.LBR,
    CountryId.LBY,
    CountryId.MDG,
    CountryId.MWI,
    CountryId.MDV,
    CountryId.MLI,
    CountryId.MAR,
    CountryId.MRT,
    CountryId.MNG,
    CountryId.MOZ,
    CountryId.MMR,
    CountryId.NAM,
    CountryId.NPL,
    CountryId.NER,
    CountryId.NGA,
    CountryId.OMN,
    CountryId.PAK,
    CountryId.PNG,
    CountryId.CIV,
    CountryId.GNQ,
    CountryId.RUS,
    CountryId.RWA,
    CountryId.SAU,
    CountryId.SEN,
    CountryId.SLE,
    CountryId.SOM,
    CountryId.LKA,
    CountryId.CAF,
    CountryId.SDN,
    CountryId.SUR,
    CountryId.STP,
    CountryId.SWZ,
    CountryId.SYR,
    CountryId.TJK,
    CountryId.TZA,
    CountryId.THA,
    CountryId.TGO,
    CountryId.TUN,
    CountryId.TUR,
    CountryId.TKM,
    CountryId.UGA,
    CountryId.UZB,
    CountryId.VNM,
    CountryId.ZMB,
    CountryId.ZWE,
    CountryId.AZE,
    CountryId.SSD,
  ])
  static readonly POL_REQUIREMENTS = new CountryVisaRequirement(CountryId.POL, [
    CountryId.AFG,
    CountryId.DZA,
    CountryId.ASM,
    CountryId.VIR,
    CountryId.AGO,
    CountryId.AIA,
    CountryId.ATA,
    CountryId.ARM,
    CountryId.ABW,
    CountryId.BHR,
    CountryId.BGD,
    CountryId.BLZ,
    CountryId.BLR,
    CountryId.BEN,
    CountryId.BMU,
    CountryId.BTN,
    CountryId.BOL,
    CountryId.BWA,
    CountryId.BVT,
    CountryId.IOT,
    CountryId.VGB,
    CountryId.BFA,
    CountryId.BDI,
    CountryId.COK,
    CountryId.CHN,
    CountryId.DOM,
    CountryId.DJI,
    CountryId.TCD,
    CountryId.EGY,
    CountryId.ECU,
    CountryId.ERI,
    CountryId.ETH,
    CountryId.FRO,
    CountryId.FLK,
    CountryId.FJI,
    CountryId.PHL,
    CountryId.GAB,
    CountryId.GMB,
    CountryId.GHA,
    CountryId.GIB,
    CountryId.GRL,
    CountryId.GUM,
    CountryId.GIN,
    CountryId.GNB,
    CountryId.GUY,
    CountryId.HTI,
    CountryId.HMD,
    CountryId.IND,
    CountryId.IDN,
    CountryId.IRQ,
    CountryId.IRN,
    CountryId.JAM,
    CountryId.YEM,
    CountryId.ZAF,
    CountryId.SGS,
    CountryId.JOR,
    CountryId.CYM,
    CountryId.KHM,
    CountryId.CMR,
    CountryId.CPV,
    CountryId.QAT,
    CountryId.KAZ,
    CountryId.KEN,
    CountryId.CCK,
    CountryId.COM,
    CountryId.COG,
    CountryId.COD,
    CountryId.PRK,
    CountryId.CUB,
    CountryId.KWT,
    CountryId.KGZ,
    CountryId.LAO,
    CountryId.LSO,
    CountryId.LBN,
    CountryId.LBR,
    CountryId.LBY,
    CountryId.LVA,
    CountryId.MDG,
    CountryId.MWI,
    CountryId.MDV,
    CountryId.MLI,
    CountryId.MAR,
    CountryId.MRT,
    CountryId.UMI,
    CountryId.MNG,
    CountryId.MSR,
    CountryId.MOZ,
    CountryId.MMR,
    CountryId.NAM,
    CountryId.NRU,
    CountryId.NPL,
    CountryId.NER,
    CountryId.NGA,
    CountryId.NIU,
    CountryId.NFK,
    CountryId.OMN,
    CountryId.PAK,
    CountryId.PNG,
    CountryId.PER,
    CountryId.PCN,
    CountryId.CIV,
    CountryId.PRI,
    CountryId.AUT,
    CountryId.GNQ,
    CountryId.RUS,
    CountryId.RWA,
    CountryId.SAU,
    CountryId.SEN,
    CountryId.MNP,
    CountryId.SLE,
    CountryId.SOM,
    CountryId.USA,
    CountryId.LKA,
    CountryId.CAF,
    CountryId.SDN,
    CountryId.SUR,
    CountryId.SJM,
    CountryId.SHN,
    CountryId.SWZ,
    CountryId.SYR,
    CountryId.TJK,
    CountryId.TZA,
    CountryId.THA,
    CountryId.TGO,
    CountryId.TKL,
    CountryId.TUN,
    CountryId.TUR,
    CountryId.TKM,
    CountryId.TCA,
    CountryId.UGA,
    CountryId.UZB,
    CountryId.CXR,
    CountryId.VNM,
    CountryId.ZMB,
    CountryId.ESH,
    CountryId.ZWE,
    CountryId.AZE,
    CountryId.ALA,
    CountryId.BES,
    CountryId.CUW,
    CountryId.GUF,
    CountryId.PYF,
    CountryId.ATF,
    CountryId.GLP,
    CountryId.GGY,
    CountryId.IMN,
    CountryId.JEY,
    CountryId.MTQ,
    CountryId.MYT,
    CountryId.NCL,
    CountryId.PSE,
    CountryId.REU,
    CountryId.BLM,
    CountryId.MAF,
    CountryId.SXM,
    CountryId.SSD,
    CountryId.WLF,
    CountryId.PSX,
  ])
  static readonly SVK_REQUIREMENTS = new CountryVisaRequirement(CountryId.SVK, [
    CountryId.AFG,
    CountryId.DZA,
    CountryId.AGO,
    CountryId.ARM,
    CountryId.BHR,
    CountryId.BGD,
    CountryId.BLZ,
    CountryId.BLR,
    CountryId.BEN,
    CountryId.BTN,
    CountryId.BOL,
    CountryId.BWA,
    CountryId.BFA,
    CountryId.BDI,
    CountryId.CHN,
    CountryId.DOM,
    CountryId.DJI,
    CountryId.TCD,
    CountryId.EGY,
    CountryId.ECU,
    CountryId.ERI,
    CountryId.ETH,
    CountryId.FJI,
    CountryId.PHL,
    CountryId.GAB,
    CountryId.GMB,
    CountryId.GHA,
    CountryId.GIN,
    CountryId.GNB,
    CountryId.GUY,
    CountryId.HTI,
    CountryId.IND,
    CountryId.IDN,
    CountryId.IRQ,
    CountryId.IRN,
    CountryId.JAM,
    CountryId.YEM,
    CountryId.ZAF,
    CountryId.JOR,
    CountryId.KHM,
    CountryId.CMR,
    CountryId.CPV,
    CountryId.QAT,
    CountryId.KAZ,
    CountryId.KEN,
    CountryId.COM,
    CountryId.PRK,
    CountryId.CUB,
    CountryId.KWT,
    CountryId.KGZ,
    CountryId.LAO,
    CountryId.LSO,
    CountryId.LBN,
    CountryId.LBR,
    CountryId.LBY,
    CountryId.MDG,
    CountryId.MWI,
    CountryId.MDV,
    CountryId.MLI,
    CountryId.MAR,
    CountryId.MRT,
    CountryId.MNG,
    CountryId.MOZ,
    CountryId.MMR,
    CountryId.NAM,
    CountryId.NRU,
    CountryId.NPL,
    CountryId.NER,
    CountryId.NGA,
    CountryId.OMN,
    CountryId.PAK,
    CountryId.PNG,
    CountryId.CIV,
    CountryId.GNQ,
    CountryId.RUS,
    CountryId.RWA,
    CountryId.SAU,
    CountryId.SEN,
    CountryId.SLE,
    CountryId.SOM,
    CountryId.LKA,
    CountryId.CAF,
    CountryId.SDN,
    CountryId.SUR,
    CountryId.STP,
    CountryId.SWZ,
    CountryId.SYR,
    CountryId.TJK,
    CountryId.TZA,
    CountryId.THA,
    CountryId.TGO,
    CountryId.TUN,
    CountryId.TUR,
    CountryId.TKM,
    CountryId.UGA,
    CountryId.UZB,
    CountryId.VNM,
    CountryId.ZMB,
    CountryId.ZWE,
    CountryId.AZE,
    CountryId.SSD,
  ])
  static readonly HUN_REQUIREMENTS = new CountryVisaRequirement(CountryId.HUN, [
    CountryId.AFG,
    CountryId.ALB,
    CountryId.DZA,
    CountryId.ASM,
    CountryId.VIR,
    CountryId.AND,
    CountryId.AGO,
    CountryId.AIA,
    CountryId.ATA,
    CountryId.ATG,
    CountryId.ARG,
    CountryId.ARM,
    CountryId.ABW,
    CountryId.AUS,
    CountryId.BHS,
    CountryId.BHR,
    CountryId.BGD,
    CountryId.BRB,
    CountryId.BLZ,
    CountryId.BLR,
    CountryId.BEN,
    CountryId.BMU,
    CountryId.BTN,
    CountryId.BOL,
    CountryId.BIH,
    CountryId.BWA,
    CountryId.BVT,
    CountryId.BRA,
    CountryId.IOT,
    CountryId.VGB,
    CountryId.BRN,
    CountryId.BFA,
    CountryId.BDI,
    CountryId.COK,
    CountryId.CHN,
    CountryId.DMA,
    CountryId.DOM,
    CountryId.DJI,
    CountryId.TCD,
    CountryId.EGY,
    CountryId.ECU,
    CountryId.ERI,
    CountryId.ETH,
    CountryId.FRO,
    CountryId.FLK,
    CountryId.FJI,
    CountryId.PHL,
    CountryId.GAB,
    CountryId.GMB,
    CountryId.GHA,
    CountryId.GIB,
    CountryId.GRD,
    CountryId.GRL,
    CountryId.GEO,
    CountryId.GUM,
    CountryId.GTM,
    CountryId.GIN,
    CountryId.GNB,
    CountryId.GUY,
    CountryId.HTI,
    CountryId.HMD,
    CountryId.HND,
    CountryId.HKG,
    CountryId.CHL,
    CountryId.IND,
    CountryId.IDN,
    CountryId.IRQ,
    CountryId.IRN,
    CountryId.ISL,
    CountryId.ISR,
    CountryId.JAM,
    CountryId.JPN,
    CountryId.YEM,
    CountryId.ZAF,
    CountryId.SGS,
    CountryId.JOR,
    CountryId.CYM,
    CountryId.KHM,
    CountryId.CMR,
    CountryId.CAN,
    CountryId.CPV,
    CountryId.QAT,
    CountryId.KAZ,
    CountryId.KEN,
    CountryId.KIR,
    CountryId.CCK,
    CountryId.COL,
    CountryId.COM,
    CountryId.COG,
    CountryId.COD,
    CountryId.PRK,
    CountryId.KOR,
    CountryId.CRI,
    CountryId.CUB,
    CountryId.KWT,
    CountryId.KGZ,
    CountryId.LAO,
    CountryId.LSO,
    CountryId.LBN,
    CountryId.LBR,
    CountryId.LBY,
    CountryId.LIE,
    CountryId.MAC,
    CountryId.MDG,
    CountryId.MKD,
    CountryId.MYS,
    CountryId.MWI,
    CountryId.MDV,
    CountryId.MLI,
    CountryId.MAR,
    CountryId.MHL,
    CountryId.MUS,
    CountryId.MRT,
    CountryId.UMI,
    CountryId.MEX,
    CountryId.FSM,
    CountryId.MDA,
    CountryId.MCO,
    CountryId.MNG,
    CountryId.MSR,
    CountryId.MOZ,
    CountryId.MMR,
    CountryId.NAM,
    CountryId.NRU,
    CountryId.NPL,
    CountryId.NER,
    CountryId.NGA,
    CountryId.NIC,
    CountryId.NIU,
    CountryId.NFK,
    CountryId.NOR,
    CountryId.NZL,
    CountryId.OMN,
    CountryId.PAK,
    CountryId.PLW,
    CountryId.PAN,
    CountryId.PNG,
    CountryId.PRY,
    CountryId.PER,
    CountryId.PCN,
    CountryId.CIV,
    CountryId.PRI,
    CountryId.GNQ,
    CountryId.RUS,
    CountryId.RWA,
    CountryId.SLV,
    CountryId.WSM,
    CountryId.SMR,
    CountryId.SAU,
    CountryId.SEN,
    CountryId.MNP,
    CountryId.SYC,
    CountryId.SLE,
    CountryId.SGP,
    CountryId.SOM,
    CountryId.ARE,
    CountryId.USA,
    CountryId.LKA,
    CountryId.CAF,
    CountryId.SDN,
    CountryId.SUR,
    CountryId.SJM,
    CountryId.SHN,
    CountryId.LCA,
    CountryId.KNA,
    CountryId.STP,
    CountryId.VCT,
    CountryId.SWZ,
    CountryId.SYR,
    CountryId.SLB,
    CountryId.CHE,
    CountryId.TJK,
    CountryId.TZA,
    CountryId.THA,
    CountryId.TWN,
    CountryId.TGO,
    CountryId.TKL,
    CountryId.TON,
    CountryId.TTO,
    CountryId.TUN,
    CountryId.TUR,
    CountryId.TKM,
    CountryId.TCA,
    CountryId.TUV,
    CountryId.UGA,
    CountryId.UKR,
    CountryId.URY,
    CountryId.UZB,
    CountryId.CXR,
    CountryId.VUT,
    CountryId.VAT,
    CountryId.VEN,
    CountryId.VNM,
    CountryId.TLS,
    CountryId.ZMB,
    CountryId.ESH,
    CountryId.ZWE,
    CountryId.MNE,
    CountryId.SRB,
    CountryId.AZE,
    CountryId.ALA,
    CountryId.BES,
    CountryId.CUW,
    CountryId.GUF,
    CountryId.PYF,
    CountryId.ATF,
    CountryId.GLP,
    CountryId.GGY,
    CountryId.IMN,
    CountryId.JEY,
    CountryId.MTQ,
    CountryId.MYT,
    CountryId.NCL,
    CountryId.PSE,
    CountryId.REU,
    CountryId.BLM,
    CountryId.MAF,
    CountryId.SPM,
    CountryId.SXM,
    CountryId.SSD,
    CountryId.WLF,
    CountryId.PSX,
  ])
  static readonly AUT_REQUIREMENTS = new CountryVisaRequirement(CountryId.AUT, [
    CountryId.AFG,
    CountryId.DZA,
    CountryId.ASM,
    CountryId.VIR,
    CountryId.AGO,
    CountryId.AIA,
    CountryId.ATA,
    CountryId.ARM,
    CountryId.ABW,
    CountryId.BHR,
    CountryId.BGD,
    CountryId.BLZ,
    CountryId.BLR,
    CountryId.BEN,
    CountryId.BMU,
    CountryId.BTN,
    CountryId.BOL,
    CountryId.BWA,
    CountryId.BVT,
    CountryId.IOT,
    CountryId.VGB,
    CountryId.BFA,
    CountryId.BDI,
    CountryId.COK,
    CountryId.CHN,
    CountryId.DOM,
    CountryId.DJI,
    CountryId.TCD,
    CountryId.EGY,
    CountryId.ECU,
    CountryId.ERI,
    CountryId.ETH,
    CountryId.FRO,
    CountryId.FLK,
    CountryId.FJI,
    CountryId.PHL,
    CountryId.GAB,
    CountryId.GMB,
    CountryId.GHA,
    CountryId.GIB,
    CountryId.GRL,
    CountryId.GUM,
    CountryId.GIN,
    CountryId.GNB,
    CountryId.GUY,
    CountryId.HTI,
    CountryId.HMD,
    CountryId.IND,
    CountryId.IDN,
    CountryId.IRQ,
    CountryId.IRN,
    CountryId.JAM,
    CountryId.YEM,
    CountryId.ZAF,
    CountryId.SGS,
    CountryId.JOR,
    CountryId.CYM,
    CountryId.KHM,
    CountryId.CMR,
    CountryId.CPV,
    CountryId.QAT,
    CountryId.KAZ,
    CountryId.KEN,
    CountryId.CCK,
    CountryId.COM,
    CountryId.COG,
    CountryId.COD,
    CountryId.PRK,
    CountryId.CUB,
    CountryId.KWT,
    CountryId.KGZ,
    CountryId.LAO,
    CountryId.LSO,
    CountryId.LBN,
    CountryId.LBR,
    CountryId.LBY,
    CountryId.LVA,
    CountryId.MDG,
    CountryId.MWI,
    CountryId.MDV,
    CountryId.MLI,
    CountryId.MAR,
    CountryId.MRT,
    CountryId.UMI,
    CountryId.MNG,
    CountryId.MSR,
    CountryId.MOZ,
    CountryId.MMR,
    CountryId.NAM,
    CountryId.NRU,
    CountryId.NPL,
    CountryId.NER,
    CountryId.NGA,
    CountryId.NIU,
    CountryId.NFK,
    CountryId.OMN,
    CountryId.PAK,
    CountryId.PNG,
    CountryId.PER,
    CountryId.PCN,
    CountryId.CIV,
    CountryId.PRI,
    CountryId.GNQ,
    CountryId.RUS,
    CountryId.RWA,
    CountryId.SAU,
    CountryId.SEN,
    CountryId.MNP,
    CountryId.SLE,
    CountryId.SOM,
    CountryId.USA,
    CountryId.LKA,
    CountryId.CAF,
    CountryId.SDN,
    CountryId.SUR,
    CountryId.SJM,
    CountryId.SHN,
    CountryId.SWZ,
    CountryId.SYR,
    CountryId.TJK,
    CountryId.TZA,
    CountryId.THA,
    CountryId.TGO,
    CountryId.TKL,
    CountryId.TUN,
    CountryId.TUR,
    CountryId.TKM,
    CountryId.TCA,
    CountryId.UGA,
    CountryId.UZB,
    CountryId.CXR,
    CountryId.VNM,
    CountryId.ZMB,
    CountryId.ESH,
    CountryId.ZWE,
    CountryId.XKX,
    CountryId.AZE,
    CountryId.ALA,
    CountryId.BES,
    CountryId.CUW,
    CountryId.GUF,
    CountryId.PYF,
    CountryId.ATF,
    CountryId.GLP,
    CountryId.GGY,
    CountryId.IMN,
    CountryId.JEY,
    CountryId.MTQ,
    CountryId.MYT,
    CountryId.NCL,
    CountryId.PSE,
    CountryId.REU,
    CountryId.BLM,
    CountryId.MAF,
    CountryId.SXM,
    CountryId.SSD,
    CountryId.WLF,
    CountryId.PSX,
  ])

  private constructor(
    id: CountryId,
    public readonly requirementCountryIds: CountryId[],
  ) {
    super(id)
  }

  static getByIdOrNull = (id: CountryId): CountryVisaRequirement | null => {
    const value = CountryVisaRequirement.all().find((item) => item.id === id)

    if (value === undefined) {
      return null
    }

    return value
  }
}
